
<template>
  <div>
    <div :style="searchFromParams.outSideStyle">
      <div
        v-for="(item, index) in searchFromParams.mainSearchList"
        :key="index"
      >
        <div
          v-if="item.type === 'cascader'"
          :style="{
              margin:item.margin ? item.margin : '',
            width: item.divWidth ? item.divWidth : '250px',
            display: 'flex',
            'align-items': 'center',
            'justify-content': 'space-between',
          }"
        >
          <span :style="{ width: item.spanWidth ? item.spanWidth : '80px' }">{{
            item.spanName
          }}</span>
          <el-cascader
            @clear="
              searchFromParams.call(item.event.clear)
                ? item.event.clear($event)
                : null
            "
             clearable
            :placeholder="
              item.placeholder ? item.placeholder : `请选择${item.Name}`"
             v-model="requestParams[item.modelObj.value]"
            :size="item.size ? item.size : ''"
            :options="item.options()"
            :props="item.props"
            @change="item.event.change($event, item.needAutoQuery)"
          >
          <!-- cascader没有clear事件 -->
          </el-cascader>
        </div>
        <div
          v-if="item.type === 'select'"
          :style="{
            width: item.divWidth ? item.divWidth : '250px',
            display: 'flex',
            'align-items': 'center',
            'justify-content': 'space-between',
          }"
        >
          <span :style="{ width: item.spanWidth ? item.spanWidth : '80px' }">{{
            item.spanName
          }}</span>
          <el-select
              :filterable="searchFromParams.call(item.event.filter)
                ? true
                : false"
            :filter-method="searchFromParams.call(item.event.filter)
                ? item.event.filter
                : null"
                 @focus="searchFromParams.call(item.event.focus)
                ? item.event.focus()
                : null"
            :style="{ margin: item.margin, width: item.inputWidth }"
            size="mini"
            
            @clear="
              searchFromParams.call(item.event.clear)
                ? item.event.clear($event)
                : null
            "
            clearable
            v-model="requestParams[item.modelObj.value]"
            @change="item.event.changeProduct($event, item.needAutoQuery)"
          >
            <el-option
              v-for="option in item.list()"
              :key="option[item.selectValue ? item.selectValue : 'value']"
              :label="option[item.selectLabel ? item.selectLabel : 'label']"
              :value="option[item.selectValue ? item.selectValue : 'value']"
            ></el-option>
          </el-select>
        </div>
        <div v-if="item.type === 'input'">
          <el-input
            @clear="
              searchFromParams.call(item.event.clear)
                ? item.event.clear($event)
                : null
            "
            :style="{
              width: item.inputWidth,
              margin: item.margin ? item.margin : '',
            }"
           
            clearable
            v-model="requestParams[item.modelObj.value]"
            :size="item.size ? item.size : ''"
            :placeholder="
              item.placeholder ? item.placeholder : `请输入${item.Name}`
            "
          >
            <template slot="prepend">{{ item.Name }}</template></el-input
          >
        </div>
        <div
          v-if="item.type === 'date-picke'"
          :style="{
            width: item.divWidth ? item.divWidth : '250px',
            display: 'flex',
            'align-items': 'center',
            'justify-content': 'space-between',
          }"
        >
          <span :style="{ width: item.spanWidth ? item.spanWidth : '80px' }">{{
            item.name
          }}</span>
          <el-date-picker
            :style="{
              margin: item.margin ? item.margin : '',
              width: item.inputWidth,
            }"
            @clear="
              searchFromParams.call(item.event.clear)
                ? item.event.clear($event)
                : null
            "
            clearable
            @change="
              searchFromParams.call(item.event.change)
                ? item.event.change($event)
                : null
            "
            :size="item.size ? item.size : ''"
            v-model="requestParams[item.modelObj.value]"
            align="right"
            type="date"
            :placeholder="
              item.placeholder ? item.placeholder : `请输入${item.name}`
            "
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
      </div>
      
      <slot name="btnLeft"></slot>
    </div>
    <div style="margin-top: 20px">
      <slot name="btn"></slot>

    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  props: {
    searchFromParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    requestParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  /* searchFromParams: {
        showSearchBtn: true,
        showAddBtn: true,
        showResetBtn: false,
        call: (param) => {
          return Object.prototype.toString.call(param) === "[object Function]";
        },
        outSideStyle: {
          width: "60%",
          display: "flex",
          "flex-wrap": "wrap",
          "align-items": "center",
        },
        mainSearchList: [
          {
            type: "input",
            size: "mini",
            inputWidth: "250px",
            needAutoQuery: false,
            Name: "船公司",
            placeholder: "",
            modelObj: {
              objName: "requestParams",
              value: "carrier",
            },
            event: {
              clear: (i) => {
                this.getList(1);
              },
            },
            margin: "0 10px 0 0",
          },
          {
            type: "select",
            divWidth: "",
            needAutoQuery: false,
            selectLabel: "",
            selectValue: "",
            spanName: "状态",
            spanWidth: "80px",
            modelObj: {
              objName: "requestParams",
              value: "status",
            },
            list: () => {
              return this.statusList;
            },
            event: {
              changeProduct: (i, autoQuery) => {},
              clear: (i) => {
                this.getList();
              },
            },
            margin: "10px 10px",
          },
          {
            type: "date-picke",
            size: "mini",
            divWidth: "",
            spanWidth: "110px",
            needAutoQuery: false,
            name: "有效时间",
            modelObj: {
              objName: "requestParams",
              value: "effectivestarttime",
            },
            placeholder: "",

            event: {
              change: (i, autoQuery) => {
                this.requestParams.effectivestarttime = i;
                // autoQuery true的话就change后马上请求
                autoQuery && this.getList();
              },
              clear: () => {
                this.getList();
              },
            },
            margin: "0px 10px",
          },
        ],
      }, */
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // console.log(this);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>



// WEBPACK FOOTER //
// src/components/QuotationManagement/jack-components/jiuyu-search-form.vue